import {Api, decryptApiResponse} from "../../../../config/Api";
import {statusAndResponse} from "../../../../util/requestHandler";

export function getTemplates(){
  return statusAndResponse(
    Api.get(`/api/tmp?limit=50&offset=0`),
    decryptApiResponse
  )
}